// Module
var code = "<form id=\"{{name}}\" name=\"{{name}}\" amt-submit transclude> </form>";
// Exports
module.exports = code;